import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import { PrivateRoute } from "./PrivateRoute";
import { ManoshalaNavbar } from "../components/Navbar/Navbar";
import { ExpertList } from "../Pages/ExpertList";
import { AddExpert } from "../Pages/AddExpert";
import { ExpertView } from "../Pages/ExpertView";
import { EditExpert } from "../Pages/EditExpert";
import { ExpertCalender } from "../components/Calender/ExpertCalender";
import { ExpertCustomCalender } from "../components/Calender/ExpertCustomCalender";
import { BookingList } from "../Pages/booking/Bookinglist";
import { ModifiedBookingList } from "../Pages/booking/ModifiedBookingList";
import { BookingView } from "../Pages/booking/BookingView";
import { EditB2BWorkshop } from "../Pages/workshops/EditB2BWorkshop";
import { EditBooking } from "../Pages/booking/EditBooking";
import { CareList } from "../Pages/care/CareList";
import { ExpertLeave } from "../components/Calender/ExpertLeaves";
import Chat from "../Pages/chat/chat";
import { InstantList } from "../Pages/instantBooking/InstantList";
import { ViewInstant } from "../Pages/instantBooking/ViewInstant";
import { MasterBookingList } from "../Pages/booking/MasterBookingList";
import { WorkshopList } from "../Pages/workshops/WorkshopList";
import { WorkshopB2BList } from "../Pages/workshops/WorkshopB2BList";
import { WorkshopB2BView } from "../Pages/workshops/WorkshopB2BView";
import { AddB2BWorkshop } from "../Pages/workshops/AddB2BWorkshop";
import { WorkshopB2BExpertList } from "../Pages/workshops/WorkshopB2BExpertList";
import { ExpertB2BList } from "../Pages/workshops/b2bexperts/ExpertB2BList";
import { ExpertB2BView } from "../Pages/workshops/b2bexperts/ExpertB2BView";
import { EditB2BExpert } from "../Pages/workshops/b2bexperts/EditB2BExpert";
import { AddB2BExpert } from "../Pages/workshops/b2bexperts/AddB2BExpert";
import { PreSessionQuestionList } from "../Pages/presessionQuestions/PreSessionQuestionList";
import { AddPreSessionQuestion } from "../Pages/presessionQuestions/AddPreSessionQuestion";
import { EditPreSessionQuestion } from "../Pages/presessionQuestions/EditPreSessionQuestion";
import { PlanDashboard } from "../Pages/plans/PlanDashboard";
import { ExpertTiming } from "../Pages/ExpertTiming";
import { NotificationList } from "../Pages/notification/NotificationList";
import { AddNotification } from "../Pages/notification/AddNotification";
import { TherapyRequestList } from "../Pages/therapyRequests/TherapyRequestList";
import { Login } from "../Pages/login/Login";
import { Home } from "../Pages/login/Home";
import { ListContext } from "../Pages/assessment/ListContext";
import { AddAssessment } from "../Pages/assessment/AddAssessment";
import { ViewAssessment } from "../Pages/assessment/ViewAssessment";
import { EditAssessments } from "../Pages/assessment/EditAssessment";
import { BilingSheetOne } from "../Pages/bilingSheet/BilingSheetOne";
import { SheetExpertList } from "../Pages/bilingSheet/ExpertList";
import { SubscriptionList } from "../Pages/booking/SubscriptionList";
import { AppAssessmentList } from "../Pages/booking/AppAssessmentList";
import { CorporateList } from "../Pages/corporates/CorporateList";
import { ProRequestList } from "../Pages/plans/ProRequestList";
import { AddProvisionalBooking } from "../Pages/provisionalBooking/AddBooking";
import { EditProvisionalBooking } from "../Pages/provisionalBooking/EditBooking";
import { AddBooking } from "../Pages/booking/AddBooking";
import { ProvisionalBookingList } from "../Pages/provisionalBooking/BookingList";
import { ExpertBilingSheet } from "../Pages/bilingSheet/ExpertBilingSheet";
import { OnboardingExpertList } from "../Pages/onboardingExperts/OnboardingExpertList";
import { OnboardingExpertView } from "../Pages/onboardingExperts/OnboardingExpertDetails";
import { WhatsappTemplateList } from "../Pages/notification/WhatsappTemplateList";
import { WhatsappLogList } from "../Pages/notification/WhatsappLogList";
import { AppNotifictaionLogList } from "../Pages/notification/AppNotifictaionLogList";

import { Records } from "../Pages/records/Records";
import { UserListContext } from "../Pages/users/ListContext";
import { EditNotification } from "../Pages/notification/EditNotification";
import { TestAssessment } from "../Pages/assessment/TestAssessment";
import { ProgrammeExpertList } from "../Pages/programmeExpert/ProgrammeExpertList";
import { SiffList } from "../Pages/users/SiffList";
import { SingleSessionBookingList } from "../Pages/booking/SingleSessionBookingList";
import { SingleBookingDetails } from "../Pages/booking/SingleBookingDetails";
import { Box } from "@chakra-ui/react";
import { AssessmentCurrentList } from "../Pages/assessment/AssessmentCurrentList";
import { AssessmentList } from "../Pages/assessment/AssessmentList";
import { GeneratePaymentLink } from "../Pages/assessment/payment/GeneratePaymentLink";
import { PaymentList } from "../Pages/assessment/payment/PaymentList";
import { AssessementRecords } from "../Pages/assessment/AssessmentRecords";
import { ExpertTreatmentPlanList } from "../Pages/ExpertTreatmentPlanList";
import { EmployeeLeavesList } from "../Pages/employee/EmployeeLeavesList";
import { ApplyForEmployeeLeave } from "../Pages/employee/ApplyForEmployeeLeave";
import { EmployeeProfile } from "../Pages/employee/EmployeeProfile";
import { EmployeeAttendance, TeamAttendance } from "../Pages/employee/EmployeeAttendance";
import { EmployeeDashboard } from "../Pages/employee/EmployeeDashboard";
import { ManageEmployees } from "../Pages/employee/ManageEmployees";
import { EmployeeMonthlyConfirmation } from "../Pages/employee/EmployeeMonthlyConfirmation";
import { EmployeeTasks } from "../Pages/employee/EmployeeTasks";
import { EmployeeTargets } from "../Pages/employee/EmployeeTargets";
import { EmployeeAppraisals } from "../Pages/employee/EmployeeAppraisals";
import { EmployeeSalary } from "../Pages/employee/EmployeeSalary";
import { EmployeeExit } from "../Pages/employee/EmployeeExit";
import { AttendanceCorrectionRequests } from "../Pages/employee/AttendanceCorrectionRequests";
import { AttendanceRuleMaster } from "../Pages/employee/admin/AttendanceRuleMaster";
import { LeaveApprovals } from "../Pages/employee/LeaveApprovals";
import { LeaveBalance } from "../Pages/employee/LeaveBalance";
import { LeaveTypeMaster } from "../Pages/employee/admin/LeaveTypeMaster";
import { ManagerDashboard } from "../Pages/employee/ManagerDashboard";
import { AdminDashboard } from "../Pages/employee/admin/AdminDashboard";
import { RolesManagement } from "../Pages/employee/admin/RolesManagement";
import { HolidayMaster } from "../Pages/employee/admin/HolidayMaster";
import { AttendanceReports } from "../Pages/employee/AttendanceReports";
import { LeaveReports } from "../Pages/employee/LeaveReports";

export const AllRoutes = () => {
  const location = useLocation();
  const showNavbar =
    location.pathname !== "/login" && location.pathname !== "/home";

  return (
    <Box display="flex">
      {showNavbar && (
        <Box>
          <ManoshalaNavbar />
        </Box>
      )}

      <Box ml="16%" width="84%">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<PrivateRoute />}>
            <Route path="" element={<BookingList />} />
            <Route path="/home" element={<Home />} />
            <Route
              path="/bookings/modified"
              element={<ModifiedBookingList />}
            />
            <Route path="experts" element={<ExpertList />} />
            <Route
              path="experts/treatmentplans"
              element={<ExpertTreatmentPlanList />}
            />
            <Route path="programme-experts" element={<ProgrammeExpertList />} />
            <Route path="siff-clients" element={<SiffList />} />
            <Route path="experts/add" element={<AddExpert />} />
            <Route path="experts/timing" element={<ExpertTiming />} />
            <Route path="experts/view/:id" element={<ExpertView />} />
            <Route path="experts/edit/:id" element={<EditExpert />} />
            <Route
              path="onboarding-experts"
              element={<OnboardingExpertList />}
            />
            <Route
              path="onboarding-experts/view/:id"
              element={<OnboardingExpertView />}
            />
            <Route path="manoshalacare/support" element={<CareList />} />
            <Route path="workshops" element={<WorkshopList />} />
            <Route path="workshopsb2b" element={<WorkshopB2BList />} />
            <Route path="workshopsb2b/view/:id" element={<WorkshopB2BView />} />
            <Route path="workshopsb2b/edit/:id" element={<EditB2BWorkshop />} />
            <Route path="workshopsb2b/add" element={<AddB2BWorkshop />} />
            <Route
              path="workshopsb2b/expertlist"
              element={<WorkshopB2BExpertList />}
            />

            <Route path="expertsb2b" element={<ExpertB2BList />} />
            <Route path="expertsb2b/view/:id" element={<ExpertB2BView />} />
            <Route path="expertsb2b/edit/:id" element={<EditB2BExpert />} />
            <Route path="expertsb2b/add" element={<AddB2BExpert />} />

            <Route
              path="presession-questions"
              element={<PreSessionQuestionList />}
            />
            <Route
              path="presession-questions/add"
              element={<AddPreSessionQuestion />}
            />
            <Route
              path="presession-questions/edit/:id"
              element={<EditPreSessionQuestion />}
            />

            <Route path="paidplans/therapyplus" element={<PlanDashboard />} />
            <Route path="paidplans/pro" element={<ProRequestList />} />
            <Route path="instant" element={<InstantList />} />
            <Route path="instant/view/:id" element={<ViewInstant />} />
            <Route path="bookings/masterview" element={<MasterBookingList />} />
            <Route path="bookings/add" element={<AddBooking />} />
            <Route path="bookings/view/:id" element={<BookingView />} />
            <Route path="bookings/edit/:id" element={<EditBooking />} />
            <Route path="calender/:id" element={<ExpertCustomCalender />} />
            <Route path="calender/leave/:id" element={<ExpertLeave />} />
            <Route path="notifications" element={<NotificationList />} />
            <Route
              path="notifications/edit/:id"
              element={<EditNotification />}
            />
            <Route
              path="notifications/logs"
              element={<AppNotifictaionLogList />}
            />
            <Route
              path="notifications/whatsapp"
              element={<WhatsappTemplateList />}
            />
            <Route
              path="notifications/whatsapp/logs"
              element={<WhatsappLogList />}
            />
            <Route path="notifications/add" element={<AddNotification />} />
            <Route path="freeconsultation" element={<ListContext />} />
            <Route
              path="freeconsultation/admin"
              element={<AssessementRecords />}
            />
            {/* <Route path="freeconsultation" element={<AssessmentList />} /> */}
            {/* <Route
              path="freeconsultationcurrent"
              element={<AssessmentCurrentList />}
            /> */}

            <Route path="freeconsultation/add" element={<AddAssessment />} />

            <Route
              path="freeconsultation/view/:id"
              element={<ViewAssessment />}
            />
            <Route
              path="freeconsultation/edit/:id"
              element={<EditAssessments />}
            />
            <Route
              path="assessment/generatepayment"
              element={<GeneratePaymentLink />}
            />
            <Route path="assessment/payments" element={<PaymentList />} />

            <Route
              path="manoshalacare/freetherapyrequest"
              element={<TherapyRequestList />}
            />
            <Route path="billing/userbilling" element={<BilingSheetOne />} />
            <Route
              path="billing/expertbilling"
              element={<ExpertBilingSheet />}
            />
            <Route
              path="billing/userbilling/expertprices"
              element={<SheetExpertList />}
            />
            <Route path="subscriptions" element={<SubscriptionList />} />
            {/* <Route path="resources/assessments" element={<AppAssessmentList />} /> */}
            <Route path="resources/users" element={<UserListContext />} />
            <Route path="resources/reports" element={<Records />} />
            <Route
              path="resources/wix-assessment"
              element={<TestAssessment />}
            />
            <Route path="corporate" element={<CorporateList />} />
            <Route path="manoshalacare/chat" element={<Chat />} />
            <Route
              path="provisional/bookings"
              element={<ProvisionalBookingList />}
            />
            <Route
              path="provisional/bookings/add"
              element={<AddProvisionalBooking />}
            />
            <Route
              path="provisional/bookings/edit/:id"
              element={<EditProvisionalBooking />}
            />
            <Route path="single/bookings" element={<SingleBookingDetails />} />

            {/* HRMS Routes */}
            <Route
              path="hrms"
              element={<Navigate to="/hrms/dashboard" replace />}
            />
            <Route path="hrms/dashboard" element={<EmployeeDashboard />} />
            <Route
              path="hrms/dashboard/manager"
              element={<ManagerDashboard />}
            />
            <Route
              path="hrms/dashboard/admin"
              element={<AdminDashboard />}
            />
            <Route path="hrms/profile" element={<EmployeeProfile />} />
            <Route path="hrms/attendance" element={<EmployeeAttendance />} />
            <Route path="hrms/attendance/team" element={<TeamAttendance />} />
            <Route
              path="hrms/attendance/corrections"
              element={<AttendanceCorrectionRequests />}
            />
            <Route
              path="hrms/admin/attendance-rules"
              element={<AttendanceRuleMaster />}
            />
            <Route path="hrms/leaves" element={<EmployeeLeavesList />} />
            <Route path="hrms/leaves/apply" element={<ApplyForEmployeeLeave />} />
            <Route path="hrms/leaves/approvals" element={<LeaveApprovals />} />
            <Route path="hrms/leaves/balance" element={<LeaveBalance />} />
            <Route
              path="hrms/admin/leave-types"
              element={<LeaveTypeMaster />}
            />
            <Route
              path="hrms/admin/roles"
              element={<RolesManagement />}
            />
            <Route
              path="hrms/admin/holidays"
              element={<HolidayMaster />}
            />
            <Route
              path="hrms/reports/attendance"
              element={<AttendanceReports />}
            />
            <Route
              path="hrms/reports/leave"
              element={<LeaveReports />}
            />
            <Route path="hrms/monthly-confirmation" element={<EmployeeMonthlyConfirmation />} />
            <Route path="hrms/tasks" element={<EmployeeTasks />} />
            <Route path="hrms/targets" element={<EmployeeTargets />} />
            <Route path="hrms/appraisals" element={<EmployeeAppraisals />} />
            <Route path="hrms/salary" element={<EmployeeSalary />} />
            <Route path="hrms/exit" element={<EmployeeExit />} />
            <Route path="hrms/admin/employees" element={<ManageEmployees />} />

            {/* Legacy routes for backward compatibility */}
            <Route path="employees" element={<EmployeeLeavesList />} />
            <Route path="employees/leaves/apply" element={<ApplyForEmployeeLeave />} />
          </Route>
        </Routes>
      </Box>
    </Box>
  );
};
